import React, {useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    ResizeBoxWrapper,
    ResizeContainer,
    TemplateSize
} from '../../Components/StyledComponents';
import {CloseIcon, ShuffleIcon} from "../../assets/icons";
import {TfiFacebook, TfiInstagram, TfiTwitter} from "react-icons/tfi";
import {GetCanvasAtResolution} from "../../utils/helpers";
import {setCanvasDimensions} from "../../store/reducers/canvasSlice";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import {inchesToPixels, sizeInInches} from "../../utils/convertToPixel";
import Stack from '@mui/joy/Stack';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Box from "@mui/joy/Box";
import Option from "@mui/joy/Option";
import Select from "@mui/joy/Select";

const socialSizes = [
    {name: 'Facebook', width: 1200, height: 630, display: {w: '138', h: '72'}, icon: <TfiFacebook size={30}/>},
    {name: 'Instagram', width: 1080, height: 1080, display: {w: '100', h: '100'}, icon: <TfiInstagram size={30}/>},
    {name: 'Twitter', width: 1200, height: 670, display: {w: '134', h: '75'}, icon: <TfiTwitter size={30}/>},
];
const printSizes = [
    {name: 'Letter', width: 1056, height: 816, display: {w: '88', h: '114'}},
    {name: 'Legal', width: 1344, height: 816, display: {w: '88', h: '120'}},
    {name: 'Tabliod', width: 1632, height: 1056, display: {w: '80', h: '124'}},
    {name: 'Prayer Card', width: 336, height: 480, display: {w: '70', h: '100'}},
    {name: 'Bookmarks', width: 240, height: 528, display: {w: '45', h: '110'}},
];

const photoSizes = [
    {name: '', width: 1536, height: 1920, display: {w: '91', h: '114'}},
    {name: '', width: 1920, height: 2880, display: {w: '80', h: '120'}},
    {name: '', width: 2304, height: 3456, display: {w: '83', h: '124'}},
];
const casketPanelSizes = [
    {name: '', width: 2976, height: 1392, display: {w: '53', h: '114'}},
    {name: '', width: 6912, height: 1392, display: {w: '24', h: '120'}},
];

const ResizePanel = ({setToggleSubMenu, resizeCanvas}) => {
    const {canvas} = useSelector((state) => state.canvas);
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const [activeSize, setActiveSize] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const dispatch = useDispatch();

    const [size, setSize] = useState({width: 0, height: 0});
    const [selectedOrientation, setSelectedOrientation] = useState( 'portrait');

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setSize((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Function to open the popup
    const openPopup = () => setIsPopupOpen(true);

    // Function to close the popup
    const closePopup = () => setIsPopupOpen(false);

    const handleSizeClick = (item) => {
        setActiveSize(item);
        openPopup();
        // const {width, height} = item;
        // if (width < 10 || height < 10) return;
        // GetCanvasAtResolution(width, height, canvas, dispatch, resizeCanvas, activeSheet);
        // dispatch(setCanvasDimensions(sizeInInches(width, height)))
    };

    const handleInputResize = (item) => {
        const {width, height} = item;
        if (width < 10 || height < 10) return

        if (selectedOrientation === 'landscape') {
            GetCanvasAtResolution(Math.max(height, width), Math.min(width, height), canvas, dispatch, resizeCanvas, activeSheet);
        } else if (selectedOrientation === 'portrait') {
            GetCanvasAtResolution(Math.min(height, width), Math.max(width, height), canvas, dispatch, resizeCanvas, activeSheet)
        }
        dispatch(setCanvasDimensions(sizeInInches(width, height)))
    };

    const closePanel = () => {
        setToggleSubMenu(false)
    }

    const resizeChangeHandler = (event, newValue) => {
        setSelectedOrientation(newValue)
    };
    // Function to handle the view selection
    const handleSelection = (view) => {
        if(!activeSize){
            closePopup();
            return;
        }
        const {width, height} = activeSize;
        if(view === 'Portrait') {
            GetCanvasAtResolution(Math.min(height, width), Math.max(width, height), canvas, dispatch, resizeCanvas, activeSheet);        }
        else{
            GetCanvasAtResolution(Math.max(height, width), Math.min(width, height), canvas, dispatch, resizeCanvas, activeSheet);
        }
        closePopup(); // Close the popup after selection
    };


    return (
        <>
            <div className='text-header'>
                <span className="heading-text">Resize</span>
                <span onClick={closePanel} className='cross-icon'><CloseIcon/></span>
            </div>
            <h3>Custom size</h3>
            <Stack spacing={1.5}>
                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <FormLabel>Width</FormLabel>
                    <Input
                        placeholder="width"
                        name="width"
                        type={'number'}
                        value={size.width}
                        onChange={handleInputChange}
                    />
                    <FormLabel>in</FormLabel>
                </Box>
                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <FormLabel>Height</FormLabel>
                    <Input
                        placeholder="height"
                        name="height"
                        type={'number'}
                        value={size.height}
                        onChange={handleInputChange}
                    />
                    <FormLabel>in</FormLabel>
                </Box>
                <Box sx={{mt: 2, justifyContent:'space-around'}} className='add-text-btn-wrapper'>
                    <div className='add-text-btn canvas-resize-btn' onClick={() => {
                        handleInputResize({height: inchesToPixels(size.height), width: inchesToPixels(size.width)})
                    }}>
                        <span>Resize canvas</span>
                    </div>
                    <div>
                        <Select
                            sx={{
                                marginRight: '10px',
                                width: 120,
                                top:0,
                            }}
                            value={selectedOrientation}
                            onChange={resizeChangeHandler}
                        >
                            <Option value="portrait">Portrait</Option>
                            <Option value="landscape">Landscape</Option>
                        </Select>
                    </div>
                </Box>
            </Stack>
            <hr className="solid-divider"/>
            <h3>Social</h3>
            <ResizeContainer>
                {
                    socialSizes.map((item) => {
                        return (
                            <ResizeBoxWrapper key={item.name}>
                                <TemplateSize style={{height: item.display.h + 'px', width: item.display.w + 'px'}}
                                              key={item.name} onClick={() => handleSizeClick(item)}>
                                    <div>{item.icon}</div>
                                    <span>{item.width} X {item.height}</span>
                                </TemplateSize>
                                <span>{item.name}</span>
                            </ResizeBoxWrapper>
                        )
                    })
                }
            </ResizeContainer>
            <hr className="solid-divider"/>
            <h3>Print</h3>
            <ResizeContainer>
                {
                    printSizes.map((item) => {
                        return (
                            <ResizeBoxWrapper key={item.width}>
                                <TemplateSize style={{height: item.display.h + 'px', width: item.display.w + 'px'}}
                                              key={item.name} onClick={() => handleSizeClick(item)}>
                                    <span>{item.width / 96}' X {item.height / 96}'</span>
                                </TemplateSize>
                                <span>{item.name}</span>
                            </ResizeBoxWrapper>
                        )
                    })
                }
            </ResizeContainer>
            <hr className="solid-divider"/>
            <h3>Photo Enlargement</h3>
            <ResizeContainer>
                {
                    photoSizes.map((item) => {
                        return (
                            <ResizeBoxWrapper key={item.width}>
                                <TemplateSize style={{height: item.display.h + 'px', width: item.display.w + 'px'}}
                                              key={item.name} onClick={() => handleSizeClick(item)}>
                                    <span>{item.width / 96}' X {item.height / 96}'</span>
                                </TemplateSize>
                                <span>{item.name}</span>
                            </ResizeBoxWrapper>
                        )
                    })
                }
            </ResizeContainer>
            <hr className="solid-divider"/>
            <h3>Casket Panel Sizes</h3>
            <ResizeContainer>
                {
                    casketPanelSizes.map((item) => {
                        return (
                            <ResizeBoxWrapper key={item.width}>
                                <TemplateSize style={{height: item.display.h + 'px', width: item.display.w + 'px'}}
                                              key={item.name} onClick={() => handleSizeClick(item)}>
                                    <span>{item.width / 96}' X {item.height / 96}'</span>
                                </TemplateSize>
                                <span>{item.name}</span>
                            </ResizeBoxWrapper>
                        )
                    })
                }
            </ResizeContainer>
            <Dialog open={isPopupOpen} onClose={closePopup} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", fontSize: "1.5rem" }}>
                    Select View
                </DialogTitle>

                <DialogContent>
                    <Typography variant="body1" align="center" sx={{ mt: 1, mb: 2 }}>
                        Please choose your preferred view:
                    </Typography>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                            onClick={() => handleSelection('Landscape')}
                        >
                            Landscape
                        </Button>

                        <Button
                            variant="outlined"
                            color="primary"
                            size="large"
                            fullWidth
                            onClick={() => handleSelection('Portrait')}
                        >
                            Portrait
                        </Button>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center", mb: 2 }} />
            </Dialog>
        </>
    );
};

export default ResizePanel;